import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ForgotPassword from './index';
import { forgotPassword } from '../../modules/user/actions';

class ForgotPasswordContainer extends React.Component {
  render() {
    return (
      <ForgotPassword {...this.props} />
    )
  }
}

function mapStateToProps(state) {
  return {
    isLoading: state.user.isLoadingForgotPassword,
    resetSuccess: state.user.resetSuccess,
    errorMessage: state.user.error,
    language: state.preference.language,
  }
}

const mapActionsToProps = {
  forgotPassword,
}

export default withRouter(connect(mapStateToProps, mapActionsToProps)(ForgotPasswordContainer));


// WEBPACK FOOTER //
// ./src/pages/ForgotPassword/container.js